import React, { FC } from 'react';
import Table from 'antd/es/table';

interface Props {
  data: { key: string, value: string }[]
}

const KeyValueTable: FC<Props> = ({ data }) => {
  const columns = [
    {
      title: 'Key',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
    },
  ];

  return (
    <div style={{ paddingRight: 48, paddingLeft: 48 }} key={JSON.stringify(data)}>
      <Table columns={columns} dataSource={data} pagination={false} />
    </div>
  );
};

export default KeyValueTable;
